module.exports = __webpack_public_path__ + "static/gooseberry-black-71176fb3cd5b16f855f06f3859756dbc.png";